// Runtime config helper - reads from window.__RUNTIME_CONFIG__ (set in index.html)
// Falls back to process.env (build-time) if runtime config not available
export function getConfig(key) {
  if (window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__[key]) {
    return window.__RUNTIME_CONFIG__[key];
  }
  return process.env[key];
}

export const API_BASE = `${getConfig("REACT_APP_BACKEND_URL")}/api`;
export const RAZORPAY_KEY_ID = getConfig("REACT_APP_RAZORPAY_KEY_ID");
